module.exports = __webpack_public_path__ + "589dca4161140f7a18070ff72087c29a.otf";